@if (pdfUrl) {
  <object
    [data]="pdfUrl | safeHtml: 'resource'"
    type="application/pdf"
    width="100%"
    height="600px"
  >
    <p>
      Your browser does not support PDFs.
      <a [href]="pdfUrl" target="_blank">Download the PDF</a>.
    </p>
  </object>
}

<div>
  <input type="button" value="Close" (click)="this.dialogRef.close()" />
</div>
